<div class="error-box">
  <div class="error-head">
    <div></div>
    <span class="icon-x-circle"></span>
    <span class="icon-x icon-close" mat-dialog-close></span>
  </div>
  <div class="error-title">Oops! We couldn’t load your page</div>
  <div class="error-description">{{ data }}</div>
  <div class="error-action">
    <core-button [button_style]="'flat'" (click)="closeAction()" class="retry-button">Retry</core-button>
  </div>
</div>
